export const pagesActions = {

};